// @flow
import React from "react"

function InstituteLogo() {
  return (
    <svg
      aria-labelledby="instituteTitle instituteDesc"
      role="img"
      className="svg-site-logo"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2676.86 726.72"
    >
      <title id="instituteTitle">MITx Online Logo</title>
      <desc id="instituteDesc">MITx Online Logo</desc>
      <g id="Artwork">
        <g>
          <path
            d="M720,720h160V240H720V720z M960,160h400V0H960V160z M720,0h160v160H720V0z M480,720h160V0H480V720z M240,560h160V0H240
            V560z M0,720h160V0H0V720z M960,720h160V240H960V720z"
          />
          <g>
            <path
              d="M1507.07,570.63c0-89.79,56.22-156.51,144.76-156.51c88.53,0,144.34,66.71,144.34,156.51
              c0,89.79-55.8,156.09-144.34,156.09C1563.29,726.72,1507.07,660.42,1507.07,570.63z M1734.07,570.63
              c0-60-26.85-106.58-81.82-106.58s-83.08,46.57-83.08,106.58c0,59.58,28.11,106.16,83.08,106.16S1734.07,630.21,1734.07,570.63z"
            />
            <path
              d="M1880.5,534.13h1.26c14.69-23.08,34.41-35.25,63.78-35.25c44.48,0,74.27,33.57,74.27,80.56V720h-57.06V587.83
              c0-23.08-13.43-39.44-37.34-39.44c-25.17,0-43.64,20.14-43.64,49.51V720h-57.06V504.76h55.8V534.13z"
            />
            <path d="M2055.88,420h57.06v300h-57.06V420z" />
            <path d="M2150.7,420h57.06v51.19h-57.06V420z M2150.7,504.76h57.06V720h-57.06V504.76z" />
            <path
              d="M2300.49,534.13h1.26c14.69-23.08,34.41-35.25,63.78-35.25c44.48,0,74.27,33.57,74.27,80.56V720h-57.06V587.83
              c0-23.08-13.43-39.44-37.34-39.44c-25.17,0-43.64,20.14-43.64,49.51V720h-57.06V504.76h55.8V534.13z"
            />
            <path
              d="M2464.55,612.17c0-63.78,43.22-113.29,106.16-113.29c69.23,0,106.16,52.87,106.16,129.65h-156.09
              c4.2,33.15,22.66,53.71,54.97,53.71c22.24,0,35.25-10.07,41.54-26.43h56.22c-7.97,38.18-41.96,70.49-97.34,70.49
              C2504.83,726.3,2464.55,676.37,2464.55,612.17z M2521.61,589.09h95.67c-1.68-27.27-19.72-46.15-45.73-46.15
              C2541.33,542.94,2526.65,560.98,2521.61,589.09z"
            />
          </g>
          <g>
            <path
              d="M1520.08,0h85.6l42.38,150.63c10.49,37.76,18.88,80.98,18.88,80.98h0.84c0,0,7.97-43.22,18.46-80.98L1728.61,0h86.85v300
              h-56.64V127.97c0-24.34,2.52-62.1,2.52-62.1h-0.84c0,0-6.71,35.25-13.01,57.06L1695.88,300h-58.32l-50.35-177.07
              c-6.29-21.82-13.01-57.06-13.01-57.06h-0.84c0,0,2.52,37.76,2.52,62.1V300h-55.81V0z"
            />
            <path d="M1862.03,0h60.84v300h-60.84V0z" />
            <path d="M1953.92,0h241.26v51.19h-90.21V300h-60.84V51.19h-90.21V0z" />
            <path
              d="M2255.18,185.88l-70.07-101.12h65.04l38.18,61.68h0.84l36.08-61.68h59.16l-66.71,100.7L2394.48,300h-67.97l-39.86-71.33
              h-0.84L2239.23,300h-62.52L2255.18,185.88z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default InstituteLogo
